export class UploadClientEvent extends Event {
    data;
    constructor(type, data, eventInitDict) {
        super(type, {
            bubbles: true,
            composed: true,
            cancelable: true,
            ...(eventInitDict || {})
        });
        this.data = data;
    }
}
export class UploadClientStateChangeEvent extends UploadClientEvent {
    constructor(state, eventInitDict) {
        super("state-change", state, eventInitDict);
    }
}
export class UploadClientFileSelectedEvent extends UploadClientEvent {
    constructor(file, eventInitDict) {
        super("file-selected", file, eventInitDict);
    }
}
export class UploadClientFileInputChangeEvent extends UploadClientEvent {
    constructor(file, eventInitDict) {
        super("file-input-change", file, eventInitDict);
    }
}
export class UploadClientFileClearedEvent extends UploadClientEvent {
    constructor(eventInitDict) {
        super("file-cleared", null, eventInitDict);
    }
}
export class UploadClientUploadStartEvent extends UploadClientEvent {
    constructor(uploadId, eventInitDict) {
        super("upload-start", uploadId, eventInitDict);
    }
}
export class UploadClientProgressUpdateEvent extends UploadClientEvent {
    constructor(percentage, eventInitDict) {
        super("progress-update", percentage, eventInitDict);
    }
}
export class UploadClientUploadErrorEvent extends UploadClientEvent {
    constructor(error, eventInitDict) {
        super("upload-error", error, eventInitDict);
    }
}
export class UploadClientUploadStartRequestedEvent extends UploadClientEvent {
    constructor(file, eventInitDict) {
        super("upload-start-requested", file, eventInitDict);
    }
}
export class UploadClientUploadCompleteEvent extends UploadClientEvent {
    constructor(result, eventInitDict) {
        super("upload-complete", result, eventInitDict);
    }
}
export class UploadClientCancelRequestedEvent extends UploadClientEvent {
    constructor(uploadId, eventInitDict) {
        super("cancel-requested", uploadId, eventInitDict);
    }
}
export class UploadClientUploadCancelledEvent extends UploadClientEvent {
    constructor(uploadId, eventInitDict) {
        super("upload-cancelled", uploadId, eventInitDict);
    }
}
export class UploadClientComponentConnectedEvent extends UploadClientEvent {
    constructor(eventInitDict) {
        super("component-connected", null, eventInitDict);
    }
}
export class UploadClientComponentDisconnectedEvent extends UploadClientEvent {
    constructor(eventInitDict) {
        super("component-disconnected", null, eventInitDict);
    }
}
export class UploadClientComponentAdoptedEvent extends UploadClientEvent {
    constructor(eventInitDict) {
        super("component-adopted", null, eventInitDict);
    }
}
export class UploadClientAttributeChangedEvent extends UploadClientEvent {
    constructor(name, oldValue, newValue, eventInitDict) {
        super("attribute-changed", { name, oldValue, newValue }, eventInitDict);
    }
}
